import 'swiper/css/bundle';
import gsap from 'gsap';

function initClipPathLeftSide() {
    gsap.to('.banner-info-section.left-clip-path', {
            keyframes: [
                {clipPath: 'polygon(100% 100%, 100% 0%, 100% 100%, 0% 100%)'},
                {clipPath: 'polygon(100% 100%, 100% 0%, 0 100%, 0% 100%)'},
                {clipPath: 'polygon(100% 100%, 100% 0%, 0% 0%, 0% 100%)'}
            ],
            duration: 1.5,
            scrollTrigger: {
                trigger: '.banner-info-section.left-clip-path',
                start: 'top bottom-=20%',
                end: 'top bottom-=20%',
                once: true
            }
        }
    )
}

function initClipPathRightSide() {
    gsap.to('.banner-info-section.right-clip-path', {
            keyframes: [
                {clipPath: 'polygon(0% 0%, 0% 100%, 100% 100%, 0% 100%)'},
                {clipPath: 'polygon(0% 0%, 100% 100%, 100% 100%, 0% 100%)'},
                {clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'}
            ],
            duration: 1.5,
            scrollTrigger: {
                trigger: '.banner-info-section.right-clip-path',
                start: 'top bottom-=20%',
                end: 'top bottom-=20%',
                once: true
            }
        }
    )
}

export function initBannerSection() {
    initClipPathLeftSide();
    initClipPathRightSide();
}